import React from "react";
import { SwatchesPicker } from "react-color";

export default function ColorPicker({ onUpdateColor }) {
  return <SwatchesPicker onChange={(color) => onUpdateColor(color.hex)} />;
}
